export const SEARCH_TRADE_ASYNC = 'SEARCH_TRADE_ASYNC';
export const SEARCH_TRADE_SUCCESS = 'SEARCH_TRADE_SUCCESS';
export const CREATE_TRADE_ASYNC = 'CREATE_TRADE_ASYNC';
export const UPDATE_TRADE_ASYNC = 'UPDATE_TRADE_ASYNC';
export const MAKE_ACTIVE_TRADE_ASYNC = 'MAKE_ACTIVE_TRADE_ASYNC';
export const MAKE_INACTIVE_TRADE_ASYNC = 'MAKE_INACTIVE_TRADE_ASYNC';
export const OPEN_FORM_CREATE_TRADE = 'OPEN_FORM_CREATE_TRADE';
export const CLOSE_FORM_CREATE_TRADE = 'CLOSE_FORM_CREATE_TRADE';
export const GET_TRADE_BY_ID_ASYNC = 'GET_TRADE_BY_ID_ASYNC';
export const GET_TRADE_BY_ID_SUCCESS = 'GET_TRADE_BY_ID_SUCCESS';
export const ADD_EDIT_TRADE_ERROR = 'ADD_EDIT_TRADE_ERROR';
export const RESET_TRADE = 'RESET_TRADE';
export const SELECT_LIST_ITEM_TRADE_ASYNC = 'SELECT_LIST_ITEM_TRADE_ASYNC';
export const SELECT_LIST_TRADE_ASYNC = 'SELECT_LIST_TRADE_ASYNC';
export const SELECT_LIST_TRADE_SUCCESS = 'SELECT_LIST_TRADE_SUCCESS';
export const SELECT_LIST_ITEM_REPAIR_BY_TRADEID_ASYNC =
  'SELECT_LIST_ITEM_REPAIR_BY_TRADEID_ASYNC';
export const SELECT_LIST_ITEM_REPAIR_BY_TRADEID_SUCCESS =
  'SELECT_LIST_ITEM_REPAIR_BY_TRADEID_SUCCESS';
export const SELECT_LIST_TRADE_FROM_REPORT_ASYNC =
  'SELECT_LIST_TRADE_FROM_REPORT_ASYNC';
export const SELECT_LIST_TRADE_BY_SUBCONTRACTOR_ID_ASYNC =
  'SELECT_LIST_TRADE_BY_SUBCONTRACTOR_ID_ASYNC';
export const SELECT_LIST_TRADE_BY_SUBCONTRACTOR_ID_SUCCESS =
  'SELECT_LIST_TRADE_BY_SUBCONTRACTOR_ID_SUCCESS';
export const EXPORT_TRADES_LIST = 'EXPORT_TRADES_LIST';
export const FETCH_LIST_ITEM_REPAIR_BY_TRADEID_ASYNC = 'FETCH_LIST_ITEM_REPAIR_BY_TRADEID_ASYNC';
export const FETCH_LIST_ITEM_REPAIR_BY_TRADEID_SUCCESS = 'FETCH_LIST_ITEM_REPAIR_BY_TRADEID_SUCCESS'





// WEBPACK FOOTER //
// ./src/Trades/constants.js